import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  useTheme,
  alpha,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

const FAQ = ({ title, faqs, subtitle }) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      sx={{
        py: { xs: 4, md: 6 },
        bgcolor: "background.neutral",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          background: (theme) =>
            `linear-gradient(180deg, ${alpha(
              theme.palette.primary.main,
              0.04
            )} 0%, ${alpha(theme.palette.primary.main, 0)} 100%)`,
        },
      }}
    >
      <Container>
        <Stack spacing={2} sx={{ mb: 8, textAlign: "center" }}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {title || "Frequently Asked Questions"}
          </Typography>
          {subtitle && (
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mx: "auto" }}
            >
              {subtitle}
            </Typography>
          )}
        </Stack>

        <Box sx={{ mx: "auto" }}>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
              sx={{
                bgcolor: "transparent",
                "&:not(:last-child)": { mb: 1 },
                "&:before": { display: "none" },
                boxShadow: "none",
                border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                borderRadius: "12px !important",
                "&.Mui-expanded": {
                  bgcolor: "background.paper",
                  borderColor: "transparent",
                  boxShadow: theme.shadows[4],
                },
              }}
            >
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={{
                      color:
                        expanded === `panel${index}`
                          ? "primary.main"
                          : "text.secondary",
                      transform:
                        expanded === `panel${index}`
                          ? "rotate(180deg)"
                          : "none",
                      transition: "transform 0.3s ease",
                    }}
                  />
                }
                sx={{
                  "& .MuiAccordionSummary-content": {
                    my: 2,
                  },
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color:
                      expanded === `panel${index}`
                        ? "primary.main"
                        : "text.primary",
                    fontWeight: 600,
                  }}
                >
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 4, pb: 4 }}>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ lineHeight: 1.8 }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FAQ;
